module.exports = __webpack_public_path__ + "static/img/ybss.d18c6ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ybss.png
// module id = Q/6S
// module chunks = 0